// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles-module__imageContainer__src-labstep-web-screens-Authentication-SigninSAML-_XtpsD"};